var map = {
	"./bg-corkboard.jpg": "af3a",
	"./bg-desk.jpg": "dfac",
	"./bg.jpg": "3625",
	"./map-large-1.jpg": "d163",
	"./map-large-2.jpg": "4efc",
	"./map-large-3.jpg": "601a",
	"./map-large-4.jpg": "cc86",
	"./map-large-5.jpg": "3fce",
	"./map-location-small-en.jpg": "662e",
	"./map-location-small-fr.jpg": "bb21",
	"./map-location-xl-en.jpg": "dcf5",
	"./map-location-xl-fr.jpg": "13fe",
	"./sand.jpg": "9dd2",
	"./timeline-xl-en.jpg": "871c",
	"./timeline-xl-fr.jpg": "dfd5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";